export default __webpack_public_path__ + "static/media/electric.18408521.svg";